import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20background%2C%20warm%20evening%20cityscape%20with%20soft%20neon%20lights%2C%20cozy%20reading%20atmosphere%2C%20books%20and%20comics%20floating%20gently%2C%20pastel%20peach%20and%20golden%20sunset%20colors%2C%20dreamy%20atmospheric%20scene%2C%20clean%20minimal%20composition%2C%20digital%20art%20illustration%2C%20warm%20tones&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="韩漫网 - 免费韩漫在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            韩漫漫画<span className="text-accent-400">免费阅读</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-2 max-w-xl mx-auto leading-relaxed">
            无删减韩漫下拉式免费在线阅读
          </p>
          <p className="text-sm md:text-base text-white/60 mb-8 max-w-lg mx-auto leading-relaxed">
            环境纯净，无弹窗广告，海量韩漫资源每日更新，让您沉浸阅读乐趣
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
            >
              立即阅读
            </Link>
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white font-medium rounded-full hover:bg-white/25 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm border border-white/20"
            >
              热门推荐
            </Link>
          </div>

          <div className="mt-10 flex items-center justify-center gap-8 text-white/50">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">120+</div>
              <div className="text-xs mt-1">漫画资源</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">每日</div>
              <div className="text-xs mt-1">持续更新</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">98%</div>
              <div className="text-xs mt-1">好评率</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}